import {Navigate} from "react-router-dom";
import LegacyDemoPanel from "./LegacyDemoPanel.jsx";
import DemoPanel from "./DemoPanel.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import DemoPanelCloud from "./DemoPanelCloud.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import DemoPage from '../pages/demo/DemoPage.jsx';
import CloudDemoPage from '../pages/demo/CloudDemoPage.jsx';
import { getSession } from "../services/session";

function Demo(props) {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let dData, bData, pageContent;

    dData = getSession();

    if (dData.migrated){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            pageContent = isV2 ? <CloudDemoPage /> : <DemoPanelCloud />;
        }else{
            pageContent = isV2 ? <DemoPage /> : <DemoPanel />;
        }
    }
    else{
        pageContent = <LegacyDemoPanel />;
    }

    /* Who may open the Demo Panel depends on which panel this session gets:
         - migrated (DemoPage / CloudDemoPage): the user's own role weight above 80
           (my_role_weight, not the impersonated role_weight), matching the NavigationV2
           section its link sits in;
         - not migrated (LegacyDemoPanel): those sessions have role NAMES, not weights, so
           compareRole on userrole, the same check the legacy Navigation uses for its Demo
           Panel link (roles above corporate-admin).
       This used to be `!compareRole("corporate-admin", dData) || ...`, which passed the whole
       session object as the role: compareRole then returns false, so the `!` let EVERY role
       through on both paths. */
    const roleAllowed = dData?.migrated
        ? iAmHigherAuthority(80, dData?.my_role_weight)
        : compareRole("corporate-admin", dData?.userrole);
    return (dData?.slauth === true && dData?.tKey != null && dData?.tKey !== "" && dData?.acnt != null && roleAllowed) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
}

export default Demo;